import { newConfig } from '../config';
import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;

export default class InsuranceCompanyService {
  constructor(client) {
    this.client = client;
  }

  async findAll({ employeeId, companyIds, page, size }) {
    const response = await this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/insurance-companies`,
      {
        params: {
          employeeId,
          companyIds,
          page,
          size
        }
      }
    );
    return response.data;
  }
}
